// extracted by mini-css-extract-plugin
module.exports = {"section":"NotFound_section__1c2UM","img":"NotFound_img__1vBSI"};